import { render, staticRenderFns } from "./WhatIDo.vue?vue&type=template&id=2f50ca46&scoped=true&"
import script from "./WhatIDo.vue?vue&type=script&lang=js&"
export * from "./WhatIDo.vue?vue&type=script&lang=js&"
import style0 from "./WhatIDo.vue?vue&type=style&index=0&id=2f50ca46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f50ca46",
  null
  
)

export default component.exports